export default __webpack_public_path__ + "static/media/driver.312e01af.png";